var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#9258E7",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8h-8c-1.1 0-1.99.9-1.99 2L10 26c0 1.1.89 2 1.99 2H24c1.1 0 2-.9 2-2V14l-6-6zm-8 18V10h7v5h5v11H12z",
    fill: "#5D43CF"
  })));
}

export default __webpack_public_path__ + "71110fe1ed0daa5352113e2b656d2133.svg";
export { SvgNote as ReactComponent };